import { IKeyValueInterface, ApplicationRouteURL, RoleLevel } from './../../shared/config';
import { AuthService } from './../../shared/models/auth.service';
import { OnInit, OnDestroy, Component } from '@angular/core';
import { DecimalFormatterService } from "../../shared/models/decimal-formatter.service";
import { SnailTrailDriverSearchModel } from '../models/snail-trail-search.model';
import { SnailTrailModel, SnailTrailSegment } from '../../snail-trail/models/snail-trail.model';
import { SnailTrailDriverService } from '../models/snail-trail-driver.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'wego-snail-trail-driver',
  template: require('../views/snail-trail-driver.component.html'),
  styles: [require('../../snail-trail/models/snail-trail.component.css')],
  providers: [SnailTrailDriverService]
})
export class SnailTrailDriverComponent implements OnInit, OnDestroy {
  isLoading: boolean;
  noDataFoundMsg: string;
  urlDriverInfo: string;

  searchModel: SnailTrailDriverSearchModel;
  errorModel: IKeyValueInterface[];
  listOfSnailTrail: SnailTrailModel[];

  currentTrip: SnailTrailModel;
  currentSegment: SnailTrailSegment;
  tripCounter: number = 0;
  segmentCounter: number = 0;
  roleLevel = RoleLevel;

  constructor(private snailTrailDriverService: SnailTrailDriverService
    , private decimalFormatter: DecimalFormatterService
    , private authService: AuthService
    , private activeRoute: ActivatedRoute, ) { }

  ngOnInit(): void {
    this.urlDriverInfo = this.authService.GetURL(ApplicationRouteURL.URL_PERSON_UPDATE);
    this.activeRoute
      .params
      .subscribe(params => {
        this.searchModel =  new SnailTrailDriverSearchModel();
        this.searchModel.bookingHashId = params['id'] ? params['id'] : params['bookingHashId'];
        this.searchModel.reportSearchType = 'PER_BOOKING';
        this.GetSnailTrail();
      });
  }

  OnSearch($event: any) {
    this.HandleFilterParam($event);
    // Get snail trail report from server
    this.GetSnailTrail();
  }

  OnExport($event: any) {
    this.HandleFilterParam($event);
    // Get snail trail excel format report from server
    this.ExportExcel();
  }


  HandleFilterParam($event: any) {
    // Assigned filter parameter to search model
    this.searchModel = new SnailTrailDriverSearchModel();

    this.searchModel.reportSearchType = $event.reportSearchType;

    if (this.searchModel.reportSearchType == 'PER_BOOKING') {
      this.searchModel.bookingHashId = $event.bookingHashId;
    }

  }

  // Get snail trail report from the server
  GetSnailTrail() {
    this.isLoading = true;
    this.snailTrailDriverService.GetSnailTrail(this.searchModel)
      .subscribe(
        res => {
          if (res.data) {
            this.listOfSnailTrail = res.data;
            this.errorModel = [];
            if (this.listOfSnailTrail && this.listOfSnailTrail.length > 0) {
              this.noDataFoundMsg = '';
              this.SelectTrip(0);
            } else {
              this.noDataFoundMsg = res.error;
            }
          } else {
            this.errorModel = res.error;
          }

          this.isLoading = false;
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  public ExportExcel() {
    this.isLoading = true;
    this.snailTrailDriverService.ExportSnailTrailExcel(this.searchModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = "SnailTrail" + new Date().toISOString() + ".xlsx";
            this.authService.DownloadXlsFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  // Trip related event
  PreviousTrip() {
    // If trip counter is 0 then don't allow to go to previous
    if (this.tripCounter != 0) {
      this.tripCounter--;
      this.SelectTrip(this.tripCounter);
    }
  }

  NextTrip() {
    // If trip counter try to reach more than record then don't allow to go to next
    if (this.listOfSnailTrail && ((this.tripCounter + 1) != this.listOfSnailTrail.length)) {
      this.tripCounter++;
      this.SelectTrip(this.tripCounter);
    }
  }

  SelectTrip(position: number) {
    // If data not available for position then don't allow
    if (this.listOfSnailTrail && position < this.listOfSnailTrail.length) {
      this.currentTrip = this.listOfSnailTrail[position];
      this.tripCounter = position;
      this.ResetSegment();
      this.SelectSegment(0);
    }
  }

  // Segment related event
  PreviousSegment() {
    // If Segment counter is 0 then don't allow to go to previous
    if (this.segmentCounter != 0) {
      this.segmentCounter--;
      this.SelectSegment(this.segmentCounter);
    }
  }

  NextSegment() {
    // If current trip is not selected then segment is not available
    // If Segment counter try to reach more than record then don't allow to go to next
    if (this.currentTrip && ((this.segmentCounter + 1) != this.currentTrip.snailTrailSegment.length)) {
      this.segmentCounter++;
      this.SelectSegment(this.segmentCounter);
    }
  }

  SelectSegment(position: number) {
    // If current trip is not selected then segment is not available
    // If data not available for position then don't allow
    if (this.currentTrip && this.currentTrip.snailTrailSegment && position < this.currentTrip.snailTrailSegment.length) {
      this.currentSegment = this.currentTrip.snailTrailSegment[position];
      this.segmentCounter = position;
    }
  }

  ResetSegment() {
    this.currentSegment = null;
    this.segmentCounter = 0;
  }

  ResetData() {
    // Reset the data based on change the filter parameter
    this.searchModel = null;
    this.errorModel = [];
    this.listOfSnailTrail = [];

    this.currentTrip = null;
    this.currentSegment = null;
    this.tripCounter = 0;
    this.segmentCounter = 0;
  }

  DecimalFormatter(value: number) {
    return this.decimalFormatter.transform(value);
  }

  ngOnDestroy(): void {

  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/snail-trail-driver/components/snail-trail-driver.component.ts